export default "__VITE_ASSET__DgGs6r8e__"